export const FORM_CONFIG = { theme: "boxed fixedLabel", validTick: "d-none" };
